export const MUNICIPALITIES = [
  'Deçan',
  'Dragash',
  'Drenas',
  'Ferizaj',
  'Fushë Kosovë',
  'Gjakovë',
  'Gjilan',
  'Graçanic',
  'Hani Elezit',
  'Istog',
  'Junik',
  'Kaçanik',
  'Kamenicë',
  'Klinë',
  'Kllokot',
  'Leposaviq',
  'Lipjan',
  'Malishevë',
  'Mamushë',
  'Mitrovicë e Jugut',
  'Mitrovicë e Veriut',
  'Novobërdë',
  'Obiliq',
  'Partesh',
  'Pejë',
  'Podujevë',
  'Prishtinë',
  'Prizren',
  'Rahovec',
  'Ranillug',
  'Shtërpce',
  'Shtime',
  'Skenderaj',
  'Suharekë',
  'Viti',
  'Vushtrri',
  'Zubin Potok',
  'Zveçan'
]
